import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-statsinflow-data',
  templateUrl: './statsinflow-data.component.html',
  styleUrls: ['./statsinflow-data.component.scss'],
  standalone: false,
})
export class StatsinflowDataComponent {
  @Input() title = '';
  @Input() data: number;
  constructor() {}
}
